import React, { useEffect } from "react"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import { selectId } from "redux/features/auth/authSlice"
import { fetchManager } from "redux/features/manager/managerThunk"
import {
  selectManagerById,
  selectFetchStatus,
} from "redux/features/manager/managerSlice"

import LoadableEntity from "components/ui/LoadableEntity"
import { ClientManagerType } from "types"

export function withClientManager<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithClientManager = (props: GenericType) => {
    const dispatch = useAppDispatch()

    const clientId = useAppSelector((state) => selectId(state)) || ""
    const clientManager = useAppSelector(
      (state) => selectManagerById(state, clientId) as ClientManagerType,
    )

    const fetchStatus = useAppSelector((state) => selectFetchStatus(state))

    const handleFetchManager = () => {
      if (!fetchStatus.isFetching) {
        dispatch(fetchManager())
      }
    }

    useEffect(() => handleFetchManager(), [])

    return (
      <LoadableEntity
        entity={clientManager}
        fetchStatus={fetchStatus}
        renderError={() => <></>}
      >
        {(clientManager) => (
          <WrappedComponent
            {...props}
            manager={clientManager}
            fetchStatus={fetchStatus}
            fetchManager={handleFetchManager}
          />
        )}
      </LoadableEntity>
    )
  }

  return WithClientManager
}
